/* @flow */
import cx from 'classnames';
import * as React from 'react';
import CurrentUser from 'auth/CurrentUser';
import MessageItemAttachment from 'chat/components/MessageItemAttachment';
import TranslatableText from 'chat/components/TranslatableText';
import MessageItemLinkPreview from 'chat/components/MessageItemLinkPreview';

import './styles/MessageItemBody.scss';

type Props = {
  item: *,
};

type State = {
  locale: ?string,
};

class MessageItemBody extends React.Component<Props, State> {
  state: State = {
    locale: this.props.item.locale,
  };

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    return this.state.locale !== nextState.locale;
  }

  isAuthor() {
    return CurrentUser.isSignedIn() && CurrentUser.getUserUuid() === this.props.item.sender.uuid;
  }

  isTranslatable = () => {
    return (
      this.props.item.locale &&
      CurrentUser.isSignedIn() &&
      CurrentUser.getUser().getISO639Locale() &&
      CurrentUser.getUser().getISO639Locale() !== this.props.item.locale &&
      !this.isAuthor()
    );
  };

  hasAttachments = () => {
    const { files } = this.props.item;
    return Array.isArray(files) && files.length > 0;
  };

  translate = () => {
    if (this.state.locale === this.props.item.locale) {
      this.setState({ locale: CurrentUser.getUser().getISO639Locale() });
    } else {
      this.setState({ locale: this.props.item.locale });
    }
  };

  renderBody() {
    if (!this.props.item.body) {
      return null;
    }

    const { body } = this.props.item;

    return (
      <div
        onClick={this.isTranslatable() ? this.translate : undefined}
        data-test-selector="translatable-message-item-body"
        className={cx('MessageItemBody-body', {
          'MessageItemBody-body-translatable': this.isTranslatable(),
          'MessageItemBody-body-bottom': !this.hasAttachments(),
        })}>
        <TranslatableText initialText={body} language={this.state.locale} />
      </div>
    );
  }

  renderAttachment() {
    const { files } = this.props.item;

    if (!this.hasAttachments()) {
      return null;
    }

    const file = files[0]; // we only support 1 files per message.

    return <MessageItemAttachment file={file} />;
  }

  renderLinkPreviews() {
    if (!Array.isArray(this.props.item.linkPreviews)) {
      return null;
    }

    const { linkPreviews } = this.props.item;

    if (linkPreviews.length <= 0) {
      return null;
    }

    return (
      <div className="MessageItemBody-linkPreviews">
        {linkPreviews.map(linkPreview => (
          <MessageItemLinkPreview key={linkPreview.url} linkPreview={linkPreview} />
        ))}
      </div>
    );
  }

  render() {
    return (
      <div className={cx({ 'MessageItemBody-self': this.isAuthor() })}>
        {this.renderBody()}
        {this.renderAttachment()}
        {this.renderLinkPreviews()}
      </div>
    );
  }
}

export default MessageItemBody;
